export const alarmRoutes = [

        { path:'alarm/benchInfo',name:'benchInfo',
            component: resolve => require(['@/views/alarm/workbench/benchInfo.vue'], resolve),props:true,
            meta:{compPath:'/alarm/workbench/benchInfo.vue'}
        }

    ]
;